import { AuthStatus, CompanyInfoStoreInterface, StaffNotificationSinitialState,  } from "@fitness-force/models";
import { ActionReducer, createReducer, on } from "@ngrx/store";
import { createAction, props } from '@ngrx/store';

import {
  DIRECTION_DETAILS, ERROR_COMPANY_DETAILS, FETCHED_COMPANY_DETAILS,
  FETCH_STAFF_LIST, FETCH_STAFF_LIST_ALL,  SELECT_LANGUAGE,
  SET_CLAIMS_DETAILS, FETCH_COUNTRY_MASTER_LIST, FETCH_COUNTRY_MASTER,
  FETCH_CITY_MASTER, FETCH_APPOINTMENT_TYPE_LIST, FETCH_CLASS_TYPE_LIST, FETCH_ROOM_LIST, LOGIN, LOGIN_SUCCESS, LOGIN_FAILED, STATSIG_INITIALIZE, FETCHED_CURRENT_LOCATION, FETCHED_TENANT_LIST_SUCCESS, FETCHED_TENANT_BY_ID_SUCCESS, SET_ACCESSED_TENANT_SUCCESS, SET_ACTIVE_TENANT, FETCH_STAGE_MASTER_SUCCESS, FETCH_SERVICETYPE_LIST_SUCCESS, FETCH_CITY_MASTER_LIST_SUCCESS, STATSIG_UPDATE_USER_SUCCESS,
  FETCH_STAFF_NOTIFICATIONS,
  FETCH_TRIAL_MASTER_LIST,
} from "./actions";
import { ActionTypes } from "./actions/clearstate.action";
import { FETCH_REPORT_LIST } from "./actions/reports.action";
import { FETCH_STATE_MASTER,  FETCH_STATE_MASTER_LIST_SUCCESS } from "./actions/state.action";
import { REPORT_STATE } from "./app.state";
import {
  CLAIMS_STATE, COUNTRY_MASTER_STATE, INITIAL_COMPANY_STATE, STAFF_STATE,
  STAGE_MASTER_STATE, TENANT_STATE, STATE_MASTER_STATE, CITY_MASTER_STATE, SERVICETYPE_STATE,
  APPOINTMENT_TYPE_STATE, CLASS_TYPE_STATE, ROOM_STATE, LOCATION_STATE, TENANT_BY_ID_STATE, authInitialState, StatsigInitialState,TRIAL_MASTER_STATE
} from "./store";
import { ThemeState } from './app.state';
import { ThemeColor } from "@fitness-force/constants";



export const companyReducer = createReducer(INITIAL_COMPANY_STATE,
  on(FETCHED_COMPANY_DETAILS, (state, action): CompanyInfoStoreInterface => {
    return {
      ...state,
      compDetails: action.companyDetails
    };
  }),
  on(ERROR_COMPANY_DETAILS, (state, action): CompanyInfoStoreInterface => {
    return {
      ...state,
      err: action.err
    };
  }),
  on(SELECT_LANGUAGE, (state, action): CompanyInfoStoreInterface => {
    return {
      ...state,
      selectedLang: action.lang
    };
  }),
  on(DIRECTION_DETAILS, (state, action): CompanyInfoStoreInterface => {
    return {
      ...state,
      direction: action.dir
    };
  }),
)

export const claimsReducer = createReducer(CLAIMS_STATE,
  on(SET_CLAIMS_DETAILS, (state, action): any | null => {
    return {
      ...state,
      claims: action.claims
    };
  })
)

export const tenantReducer = createReducer(TENANT_STATE,
  on(FETCHED_TENANT_LIST_SUCCESS, (state, action): any => {
    return {
      ...state,
      all_tenant: action.all_tenant,
    };
  }),
  on(SET_ACTIVE_TENANT, (state, action): any => {
    return {
      ...state,
      selected_tenant: action.selected_tenant
    };
  }),
  on(SET_ACCESSED_TENANT_SUCCESS, (state, action): any => {
    return {
      ...state,
      accessed_tenant: action.accessed_tenant
    };
  })
)

export const staffReducer = createReducer(STAFF_STATE,
  on(FETCH_STAFF_LIST, (state, action): any => {
    return {
      ...state,
      staffList: action.staffList
    };
  }),
  on(FETCH_STAFF_LIST_ALL, (state, action): any => {
    return {
      ...state,
      staffListAll: action.staffListAll
    };
  })
)

export const reportReducer = createReducer(REPORT_STATE,
  on(FETCH_REPORT_LIST, (state, action): any => {
    return {
      ...state,
      reportList: action.reportList
    };
  })
)

export const stageReducer = createReducer(STAGE_MASTER_STATE,
  on(FETCH_STAGE_MASTER_SUCCESS, (state, action): any => {
    return {
      ...state,
      stages: action.stages
    };
  })
)

export const countryListReducer = createReducer(COUNTRY_MASTER_STATE,
  on(FETCH_COUNTRY_MASTER_LIST, (state, action): any => {
    return {
      ...state,
      countries: action.countries
    };
  }),
  on(FETCH_COUNTRY_MASTER, (state, action): any => {
    return {
      ...state,
      country: action.country
    };
  })
)

export const appointmentTypeReducer = createReducer(APPOINTMENT_TYPE_STATE,
  on(FETCH_APPOINTMENT_TYPE_LIST, (state, action): any => {
    return {
      ...state,
      appointmentTypes: action.appointmentTypes
    };
  })
)

export const stateListReducer = createReducer(STATE_MASTER_STATE,
  on(FETCH_STATE_MASTER_LIST_SUCCESS, (state, action): any => {
    return {
      ...state,
      states: action.states
    };
  }),
  on(FETCH_STATE_MASTER, (state, action): any => {
    return {
      ...state,
      state: action.state
    };
  })
)

export const classTypeReducer = createReducer(CLASS_TYPE_STATE,
  on(FETCH_CLASS_TYPE_LIST, (state, action): any => {
    return {
      ...state,
      classTypes: action.classTypes
    };
  })
)

export const cityListReducer = createReducer(CITY_MASTER_STATE,
  on(FETCH_CITY_MASTER_LIST_SUCCESS, (state, action): any => {
    return {
      ...state,
      cities: action.cities
    };
  }),
  on(FETCH_CITY_MASTER, (state, action): any => {
    return {
      ...state,
      city: action.city
    };
  })
)


export const serviceTypeReducer = createReducer(SERVICETYPE_STATE,
  on(FETCH_SERVICETYPE_LIST_SUCCESS, (state, action): any => {
    return {
      ...state,
      items: action.serviceTypeList
    };
  })
)

export const roomReducer = createReducer(ROOM_STATE,
  on(FETCH_ROOM_LIST, (state, action): any => {
    return {
      ...state,
      rooms: action.rooms
    };
  })
)

export const locationReducer = createReducer(LOCATION_STATE,
  on(FETCHED_CURRENT_LOCATION, (state, action): any => {
    return {
      ...state,
      location: action.location
    };
  })
)

export function clearState<State extends {}>(reducer: ActionReducer<State>): ActionReducer<State> {
  return function (state, action) {
    if (action.type === ActionTypes.LOGOUT)
      state = undefined;

    return reducer(state, action);
  };
}


export const TenantReducer = createReducer(TENANT_BY_ID_STATE,
  on(FETCHED_TENANT_BY_ID_SUCCESS, (state, action): any => {
    return {
      ...state,
      tenant: action.tenant
    };
  })
)


export const StatsigReducer = createReducer(StatsigInitialState,
  on(STATSIG_UPDATE_USER_SUCCESS, (state,action) => {
      return {
        ...state,
        user: action.user,
      }
  }));



export const authReducer = createReducer(authInitialState,
  on(LOGIN, (state) => ({
    ...state,
    status: AuthStatus.IN_PROGRESS,
    error: null, // Clear any previous errors on new login attempt
  })),
  on(LOGIN_SUCCESS,  (state, action) => ({
    ...state,
    loggedIn: true,
    status: AuthStatus.INIT,
    user: action.user,
    error: null, // Clear any previous errors on successful login
  })),
  on(STATSIG_INITIALIZE,  (state, action) => ({
    ...state,
  })),
  on(LOGIN_FAILED,  (state, action) => {
   return  {
    ...state,
    status: AuthStatus.ERROR,
    loggedIn: false,
    user: null,
    error:action.error
  };}),
)

export const staffNotificationReducer = createReducer(StaffNotificationSinitialState,
  on(FETCH_STAFF_NOTIFICATIONS, (state, action): any | null => {
    return {
      ...state,
      staffNotification: action.staffNotifications
    };
  })
)

export const setTheme = createAction(
  '[Theme] Set Theme',
  props<{ theme: any }>()
);

const initialThemeState: any = {
  currentTheme: {
    name: 'Light Mode',
    icon: 'fa fa-sun',
    themeMode: 'light',
    selectedTheme: 'Lara',
    selectedColor: 'indigo',
    themes: [
      { themeName: 'Lara', colors:['indigo', 'emerald', 'zinc', 'green', 'lime', 'red', 'orange', 'amber', 'yellow', 'teal', 'sky', 'blue', 'violet', 'purple', 'fuchsia', 'pink', 'rose', 'slate', 'gray'] },
      { themeName: 'Aura', colors:['indigo', 'emerald', 'zinc', 'green', 'lime', 'red', 'orange', 'amber', 'yellow', 'teal', 'sky', 'blue', 'violet', 'purple', 'fuchsia', 'pink', 'rose', 'slate', 'gray'] },
      { themeName: 'Material', colors:['indigo', 'emerald', 'zinc', 'green', 'lime', 'red', 'orange', 'amber', 'yellow', 'teal', 'sky', 'blue', 'violet', 'purple', 'fuchsia', 'pink', 'rose', 'slate', 'gray'] },
      { themeName: 'Nora', colors:['indigo', 'emerald', 'zinc', 'green', 'lime', 'red', 'orange', 'amber', 'yellow', 'teal', 'sky', 'blue', 'violet', 'purple', 'fuchsia', 'pink', 'rose', 'slate', 'gray'] },
    ],
  }
};

export const themeReducer = createReducer(
  initialThemeState,
  on(setTheme, (state, { theme }) => ({ ...state, currentTheme: theme }))
);

export const trialMasterReducer = createReducer(TRIAL_MASTER_STATE,
  on(FETCH_TRIAL_MASTER_LIST, (state, action): any => {
    return {
      ...state,
      trials: action.trials
    };
  })
)


